/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type StatsQueryParams = {
    playerId?: number;
    teamId?: number;
    gameId?: number;
    leagueId?: number;
    season?: string;
    seasonType?: StatsQueryParams.seasonType;
    format?: StatsQueryParams.format;
    types?: Array<'BOX_SCORE' | 'ADVANCED' | 'SHOT_PROFILE'>;
    limit?: number;
};
export namespace StatsQueryParams {
    export enum seasonType {
        PRE_SEASON = 'Pre Season',
        REGULAR_SEASON = 'Regular Season',
        PLAYOFFS = 'Playoffs',
        PLAY_IN_SEASON = 'Play-In Season',
        ALL_STAR_WEEKEND = 'All Star Weekend',
        IST_CHAMPIONSHIP = 'IST Championship',
        QUALIFYING = 'Qualifying',
    }
    export enum format {
        TOTALS = 'TOTALS',
        PER_GAME = 'PER_GAME',
        PER_MINUTE = 'PER_MINUTE',
        PER_36_MINUTES = 'PER_36_MINUTES',
        PER_40_MINUTES = 'PER_40_MINUTES',
        PER_48_MINUTES = 'PER_48_MINUTES',
        PER_POSSESSION = 'PER_POSSESSION',
        PER_100_POSSESSIONS = 'PER_100_POSSESSIONS',
    }
}

